(() => {
  const selector = '[data-dontix-lazy-video]';
  const observed = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const load = video => {
    if (video.dataset.loaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
      delete source.dataset.src;
    });
    video.dataset.loaded = 'true';
    video.load();
  };
  const show = video => {
    load(video);
    if (video.dataset.autoplay === 'true' && !reducedMotion.matches) {
      video.muted = true;
      video.controls = true;
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') {
        playback.catch(() => { video.controls = true; });
      }
    } else {
      video.controls = true;
    }
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) show(entry.target);
          else entry.target.pause();
        });
      }, { rootMargin: '200px 0px' })
    : null;
  const setup = root => {
    root.querySelectorAll(selector).forEach(video => {
      if (observed.has(video)) return;
      observed.add(video);
      if (observer) observer.observe(video);
      else { load(video); video.controls = true; }
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

